import { render } from "./fiche_medical_invoice.vue?vue&type=template&id=72cb1c9c"
import script from "./fiche_medical_invoice.vue?vue&type=script&lang=js"
export * from "./fiche_medical_invoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__